import { IMaintenanceInfoResponse } from '@/store/api/maintenanceApi';
import { normalizePhoneNumber } from '@/utils/common/regex';

type UploadLike = { uri?: string; type?: string; name?: string; file?: { uri: string; type: string; name: string } };

export interface BuildTicketArgs {
  maintenanceInfo: IMaintenanceInfoResponse | undefined;
  locationName: string;
  categoryName: string;
  subCategoryName: string;
  problemName: string;
  severityName: string;
  description: string;
  phoneNumber: string;
  permissionChoice: null | 'yes' | 'no';
  attachments?: UploadLike[];
  petsDescription?: string;
}

export const buildTicketFormData = (args: BuildTicketArgs): FormData => {
  const {
    maintenanceInfo,
    locationName,
    categoryName,
    subCategoryName,
    problemName,
    severityName,
    description,
    phoneNumber,
    permissionChoice,
    attachments,
    petsDescription,
  } = args;

  const formData = new FormData();

  const locId = maintenanceInfo?.locations?.find(l => l.name === locationName)?.id || 0;
  const prioId = maintenanceInfo?.priorities?.find(p => p.name === severityName)?.id || 0;
  const catId = maintenanceInfo?.categories?.find(c => c.name === categoryName)?.id || 0;
  const subCatId = maintenanceInfo?.categories?.find(c => c.name === categoryName)?.subCategories?.find(s => s.name === subCategoryName)?.id || 0;
  const problemId = maintenanceInfo?.problems?.find(p => p.name === problemName)?.id || 0;

  formData.append('permissionToEnter', String(permissionChoice === 'yes'));
  formData.append('maintenanceLocationId', String(locId));
  formData.append('maintenanceLocationName', locationName);
  formData.append('maintenanceCategoryId', String(catId));
  formData.append('maintenanceCategoryName', categoryName);
  formData.append('maintenanceSubCategoryId', String(subCatId));
  formData.append('maintenanceSubCategoryName', subCategoryName);
  formData.append('maintenanceProblemId', String(problemId));
  formData.append('maintenanceProblemName', problemName);
  formData.append('maintenancePriorityId', String(prioId));
  formData.append('maintenancePriorityName', severityName);
  formData.append('problemDescription', description);
  formData.append('phoneNumber', normalizePhoneNumber(phoneNumber));

  if (petsDescription) {
    formData.append('petsDescription', petsDescription);
  }

  if (attachments && attachments.length) {
    attachments.forEach((f) => {
      const filePart = f.file ? f.file : { uri: f.uri as string, type: f.type || 'application/octet-stream', name: f.name || 'file' };
      formData.append('files', filePart as any);
    });
  }

  return formData;
};


